export function isSellAndRentAdminCancelEnabled() {
  return process.env.SELL_AND_RENT_ADMIN_CANCEL_ENABLED === "true";
}
